import "./Header.scss";
import { Box } from "@husqvarna/ui-core";
import InfoDrawer from "../InfoDrawer";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import useProjectExport from "../../hooks/useProjectExport";
import useProjectGeoJsonExport from "../../hooks/useProjectGeoJsonExport";
import FeedbackToast, { FeedbackToastProps } from "../FeedbackToast";
import LeftNavigation from "./LeftNavigation/LeftNavigation";
import RightNavigation from "./RightNavigation/RightNavigation";
import { setShowError } from "../../../project/projectSlice";
import { useIntl } from "react-intl";

const Header = () => {
  const intl = useIntl();
  const [info, setInfo] = useState(false);
  const selectedProject = useSelector((state: RootState) => state.project.selectedProject);
  const showError = useSelector((state: RootState) => state.project.showError);
  const dispatch = useDispatch();

  const [toastProps, setToastProps] = useState<FeedbackToastProps>({
    show: false,
    success: false,
    text: "",
  });
  const onShowToast = (toast: FeedbackToastProps) => {
    setToastProps(toast);
  };
  const { isExporting, exportProject } = useProjectExport(selectedProject, onShowToast);
  const { isExportingGeoJson, exportInstallationGeoJson } = useProjectGeoJsonExport(
    selectedProject,
    onShowToast
  );
  const isExportingAny = isExporting || isExportingGeoJson;

  useEffect(() => {
    setToastProps({
      show: showError,
      success: false,
      text: intl.formatMessage({
        id: "general.somethingwentwrong",
        defaultMessage: "Something went wrong. Please reload page and retry the latest action."
      })
    })
    setTimeout(() => {
            dispatch(setShowError(false));
    }, 5000)
  }, [showError])

  const handleExportProject = () => {
    exportProject().finally(() => {
      setTimeout(() => {
        setToastProps((prevProps) => ({...prevProps, show: false}));
      }, 2500)
    });
  };

  const handleExportInstallationJson = () => {
    exportInstallationGeoJson().finally(() => {
      setTimeout(() => {
        setToastProps((prevProps) => ({ ...prevProps, show: false }));
      }, 2500);
    });
  };

  return (
    <Box
      component="header"
      className="tcsp-header"
      alignItems="center"
      justifyContent="space-between"
      flexGrow={0}
      flexShrink={0}
    >
      <div id="toast-container"></div>
      <div id="leasing-toast-container"></div>
      <LeftNavigation selectedProject={selectedProject} />
      <RightNavigation
        selectedProject={selectedProject}
        isExporting={isExportingAny}
        onExport={() => handleExportProject()}
        onExportInstallationJson={() => handleExportInstallationJson()}
        onOpenAbout={() => setInfo(true)}/>

      <FeedbackToast
        show={toastProps.show}
        success={toastProps.success}
        text={toastProps.text}
      />
      <InfoDrawer isOpen={info} onClosing={() => setInfo(false)}/>
    </Box>
  );
};

export default Header;
